import React, { useEffect, useState } from 'react';
import Label from '../../../../../components/common-components/label/Label';
import Heading from '../../../../../components/common-components/heading/Heading';
import { HEADING } from '../../../../../components/common-components/heading/Constants';
import Table from '../../../../Table/Index';
import ButtonDropdown from '../../../../../components/common-components/buttonDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { deleteMasterAllergy, getMasterAllergy } from './MasterAllergySaga';
import { componentKey,setOpenAddAllergyModal } from './MasterallergySlice';
import MasterAllergyEditModel from './MasterAllergyEditModel';
import MasterDeleteModel from './MasterDeleteModel';
import MasterAddAllergyModel from './MasterAddAllergyModel';


function MasterAllergy() {
    const { masterAllergyData ,isOpenAddAllergyModal} = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();
    const [openEditModal, setOpenEditModal] = useState({ open: false, data: {} });
    const [openDeleteModal, setOpenDeleteModal] = useState({ open: false, data: {} });
    const [paginationState, setPaginationState] = useState({
        pageNumber:  1,
        limit: 10,
        totalRecords: masterAllergyData?.data?.totalRecords ||  0,
    });

    useEffect(() => {
        setPaginationState((prevState) => ({
            ...prevState,
            totalRecords: masterAllergyData?.data?.totalRecords || 0,
        }));
    }, [masterAllergyData?.data?.totalRecords]);


    const role = localStorage.getItem('role')

    useEffect(() => {
        const payload = {
            page: paginationState?.pageNumber
        }
        dispatch(getMasterAllergy(payload));
    }, [dispatch, paginationState?.pageNumber]);


    const finalDelete = (action) => {
        const payload = {
            id:  openDeleteModal?.data?.uuid,
            setOpenDeleteModal:setOpenDeleteModal
        }
        
        if (action === "yes") {
            dispatch(deleteMasterAllergy(payload));
            return;
        }
        setOpenDeleteModal({ open: false, data: {} });
    };

    const columns = [
        {
            field: 'name',
            label: <Label fontWeight="font-bold">Name</Label>,
            renderLogic: (row) => {
                return (
                    <>
                        <div>
                            <Heading fontWeight="bold" type={HEADING.H1} color="gray-500" fontSize={'md'}>
                                {row.name || "-"}
                            </Heading>
                        </div>
                    </>
                );
            },
        },
        {
            field: 'category',
            label: <Label fontWeight="font-bold">Category</Label>,
            renderLogic: (row) => {
                return (
                    <>
                        <div>
                            <Heading type={HEADING.H1} color="gray-500" fontSize={'md'}>
                                {row.category || ""}
                            </Heading>
                        </div>
                    </>
                );
            },
        },
         {
            field: 'reaction',
            label: <Label fontWeight="font-bold">Reaction</Label>,
            renderLogic: (row) => {
                return (
                    <>
                        <div>
                            <Heading type={HEADING.H1} color="gray-500" fontSize={'md'}>
                                {row.reaction || "-"}
                            </Heading>
                        </div>
                    </>
                );
            },
        },
        {
            field: 'action',
            label: role !== 'Front Desk' && <Label fontWeight="font-bold">Action</Label>,
            renderLogic: (row) => {
                const handleEdit = (row) => {
                    setOpenEditModal({ open: true, data: row });
                  
                };

                const handleDelete = (row) => {
                    setOpenDeleteModal({ open: true, data: row });
                }
                
                return (
                    <>
                        {role !== 'Front Desk' && <div className="flex items-center">
                            <div>
                                <Heading type={HEADING.H1} color="gray-500" fontSize={'md'}>{row.action}</Heading>
                            </div>
                            <ButtonDropdown
                                customBtnClass="p-0"
                                endIcon="moreVertIcon"
                                options={[
                                    { label: 'Edit', value: 'Edit' },
                                    // { label: 'View', value: 'View' },
                                    { label: 'Delete', value: 'Delete' },
                                ]}
                                selectCb={(option) => {
                                    switch (option.value) {
                                        case 'Edit':
                                            handleEdit(row);
                                            break;
                                        case 'Delete':
                                            handleDelete(row);
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                            />
                        </div>}
                    </>
                );
            },
        },
    ];
    return (
        <div>
            <div className='pb-[30px]'>
                <Table isPagination={false} coloumns={columns} rows={masterAllergyData?.data?.allergies}
                   paginationProps={{
                    isPagination: true,
                    totalCount: paginationState?.totalRecords,
                    limit: paginationState?.limit,
                    onPageChange: (page) => {
                        setPaginationState((prev) => ({
                            ...prev,
                            pageNumber: page,
                        }));
                    },
                }}                 
                 />
            </div>
            {openEditModal?.open &&<MasterAllergyEditModel data={openEditModal?.data} open={openEditModal?.open} close={()=>{setOpenEditModal({open:false,data:{}})}} />}
            {openDeleteModal?.open && <MasterDeleteModel open={openDeleteModal?.open} message={"allergy"} close={(action) =>  finalDelete(action)} />}
            {isOpenAddAllergyModal && (
                <MasterAddAllergyModel
                    data={null}
                    open={isOpenAddAllergyModal}
                    close={() => dispatch(setOpenAddAllergyModal(false))}
                />
            )}
        </div>
    );
}

export default MasterAllergy;
